import city from "./Resources/city.json"

export const OnlineMerchantCityOptions = city.city.map(({ value, name }) => ({
  key: value,
  title: name,
  value: value,
}))